"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));
var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));
var _Popover = _interopRequireDefault(require("@react/react-spectrum/Popover"));
var _More = _interopRequireDefault(require("@react/react-spectrum/Icon/More"));
var _SDC_More_18_N = _interopRequireDefault(require("dc-icons/viewer2021/SDC_More_18_N.svg"));
var _reactIntl = require("react-intl");
var _SideMenu = _interopRequireDefault(require("../side-menu/SideMenu"));
var _PropTypeCustomAction = require("../../prop-type-custom-action/PropTypeCustomAction");
var _AnalyticsConstants = _interopRequireDefault(require("../../../../../constants/AnalyticsConstants"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../../util/ServiceRegistry"));
require("!style-loader!css-loader!./SideMenuCallToAction.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const SideMenuCallToAction = props => {
  const {
    sideMenuActions,
    intl
  } = props;
  const appStore = _ServiceRegistry.default.getService("AppStore");
  let overlayRef;
  if (!(sideMenuActions.length > 0 || appStore.configStore.hasAdobeMenuActions())) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  let moreActionClassName = "sdk-CallToAction-sideMenuButton";
  let moreActionIcon = () => /*#__PURE__*/_react.default.createElement(_More.default, null);
  if (appStore.enableModernViewer) {
    moreActionClassName = "sdk-CallToAction-sideMenuButton-modernViewer";
    moreActionIcon = () => /*#__PURE__*/_react.default.createElement(_SDC_More_18_N.default, null);
  }
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    trigger: "click",
    placement: "bottom right",
    ref: oRef => {
      overlayRef = oRef;
    },
    onShow: () => {
      appStore.setSideMenuOpen(true);
      _ServiceRegistry.default.getService("AnalyticsProviderService").sendEvent(_AnalyticsConstants.default.SIDE_MENU_CALL_TO_ACTION);
    },
    onClick: () => {
      overlayRef.hide();
    },
    onHide: () => {
      appStore.setSideMenuOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: moreActionClassName,
    quiet: true,
    variant: "action",
    icon: moreActionIcon(),
    "aria-haspopup": "true",
    "aria-label": intl.formatMessage({
      id: "sideMenuCallToAction.label"
    })
  }), /*#__PURE__*/_react.default.createElement(_Popover.default, {
    variant: "default",
    className: (0, _classnames.default)(["sdk-CallToAction-popover", "sdk-CallToAction-sideMenuPopOver"])
  }, /*#__PURE__*/_react.default.createElement(_SideMenu.default, {
    actions: sideMenuActions
  })));
};
SideMenuCallToAction.propTypes = {
  sideMenuActions: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_PropTypeCustomAction.propTypeJsonCustomAction, _PropTypeCustomAction.propTypeReactCustomAction])).isRequired,
  intl: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)(SideMenuCallToAction);